import { connect } from 'react-redux';
import { logoutAction } from '@smorder/logic';
import AppBar from './appbar';
import { setMode, setOrderSearchValue } from '../../reducers/order.reducers';
import { toggleFullScreen } from '../../reducers/app.reducers';

const mapStateToProps = state => ({
  selectedMode: state.orders.selectedMode,
  selectableDurations: state.orders.selectableDurations,
  ordersStartDate: state.orders.ordersStartDate,
  localSettings: state.app.localSettings,
  signalRconnected: state.app.signalRconnected,
  preOrderDaysAheadAllowed: state.app.options.preOrderDaysAheadAllowed || 0,
  orders: state.orders.orders,
  loading: state.orders.loading,
  orderSearchValue: state.orders.orderSearchValue,
  isFullScreen: state.app.inButtonActivatedFullScreen,
  showToggleFullScreenButton: state.app.showToggleFullScreenButton,
  user: state.authentication.user,
});

const mapDispatchToProps = dispatch => ({
  setMode: (modeid, startdate, enddate) => {
    dispatch(setMode({ modeid, startdate, enddate }));
  },
  setOrderSearchValue: value => dispatch(setOrderSearchValue(value)),
  logout: () => dispatch(logoutAction()),
  toggleFullScreen: () => dispatch(toggleFullScreen()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppBar);
